import { useEffect, useState } from 'react';
import { RootState } from 'apps/frontend/store/Store';
import { useSelector } from 'react-redux';
import Link from 'next/link';

const MarketMovers = ({ marketId }) => {
  const [gainers, setGainers] = useState<any>([]);
  const [losers, setLosers] = useState<any>([]);

  const marketMovers = useSelector((state: RootState) => state.marketmovers);

  useEffect(() => {
    setGainersLosers(marketId);
  }, [marketId, marketMovers]);

  const setGainersLosers = (marketId) => {
    // console.log('IDcurrentMarket=>', marketId);
    const currentMarket = marketMovers[marketId]?.data
      ? marketMovers[marketId]?.data
      : {};
    // console.log('currentMarket=>', currentMarket);
    if (currentMarket) {
      let allGainers = currentMarket?.gainers || [];
      if (Array.isArray(allGainers) && allGainers?.length > 0) {
        allGainers = allGainers
          .slice()
          .sort((a, b) => b?.ChangePercent - a?.ChangePercent);
      }
      // console.log('allGainersCurrentMarket=>', allGainers);
      setGainers(allGainers);

      let allLosers = currentMarket?.losers || [];
      // console.log('allLosersCurrentMarket=>', allLosers);
      setLosers(allLosers);
    }
  };

  // useEffect(() => {
  //   console.log('gainers==>', gainers);
  // }, [gainers]);

  // useEffect(() => {
  //   console.log('losers==>', losers);
  // }, [losers]);

  return (
    <div className="row">
      {marketId == '999' ? (
        <>
          <div className="col-md-6">
            <h3>الرابحون</h3>
            {gainers && gainers?.length && gainers?.length > 0 ? (
              <div className="table-responsive">
                <table className="table table-borderless">
                  <tbody>
                    {gainers.map((gainer: any, index: number) => {
                      const row = gainer;
                      //   console.log('rowCurrentMarket=>',row);
                      const percentageWidth =
                        index == 0
                          ? 100
                          : (row?.ChangePercent / gainers[0]?.ChangePercent) *
                          100;
                      // console.log("1-",percentageWidth,"2-",row?.ChangePercent,"3-",gainers[0]?.ChangePercent)
                      if (index >= 5) return null;
                      return (
                          <tr className="marketMoversRow cursor-pointer Nine" key={row?.TickerID}>
                            <td>
                              <strong>{row?.TickerSymbol}</strong>
                            </td>
                            <td className="desc">
                              {row?.TickerArabicName}
                            </td>
                            <td className="text-success">{`${row?.ChangePercent}%`}</td>
                            <td style={{ width: '50%' }}>
                              <div className="progress p-0">
                                <div
                                  className="progress-bar bg-success"
                                  style={{ width: `${percentageWidth}%` }}
                                ></div>
                              </div>
                            </td>
                          </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            ) : (
              <></>
            )}
          </div>
          <div className="col-md-6">
            <h3>الخاسرون</h3>
            {losers && losers?.length && losers?.length > 0 ? (
              <div className="table-responsive">
                <table className="table table-borderless">
                  <tbody>
                    {losers.map((loser: any, index: number) => {
                      const row = loser;
                      const percentageWidth =
                        index == 0
                          ? 100
                          : (row?.ChangePercent / losers[0]?.ChangePercent) *
                          100;
                          if (index >= 5) return null;
                      console.log("1.", percentageWidth, "2.", row?.ChangePercent, "3.", losers[0]?.ChangePercent)
                      return (
                            <tr className="marketMoversRow cursor-pointer Nine" key={row?.TickerID}>
                              <td>
                                <strong>{row?.TickerSymbol}</strong>
                              </td>
                              <td className="desc">
                                {row?.TickerArabicName}
                              </td>
                              <td className="text-danger">
                                {parseInt(row?.ChangePercent) > 0
                                  ? `${Math.abs(row?.ChangePercent)}%`
                                  : `${Math.abs(row?.ChangePercent)}%-`}
                              </td>
                              <td style={{ width: '50%' }}>
                                <div className="progress p-0">
                                  <div
                                    className="progress-bar bg-danger"
                                    style={{
                                      width: `${Math.abs(percentageWidth)}%`,
                                    }}
                                  ></div>
                                </div>
                              </td>
                            </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            ) : (
              <></>
            )}
          </div>
        </>
      ) : (
        <>
          <div className="col-md-6">
            <h3>الرابحون</h3>
            {gainers && gainers?.length && gainers?.length > 0 ? (
              <div className="table-responsive">
                <table className="table table-borderless">
                  <tbody>
                    {gainers.map((gainer: any, index: number) => {
                      const row = gainer;
                      //   console.log('rowCurrentMarket=>',row);
                      const percentageWidth =
                        index == 0
                          ? 100
                          : (row?.ChangePercent / gainers[0]?.ChangePercent) *
                          100;
                          if (index >= 5) return null;
                      // console.log("1-",percentageWidth,"2-",row?.ChangePercent,"3-",gainers[0]?.ChangePercent)
                      return (
                            <Link href={'/quotes/' + row?.TickerID} key={row?.TickerID}>
                              <tr className="marketMoversRow cursor-pointer" key={row?.TickerID}>
                                <td>
                                  <strong>{row?.TickerSymbol}</strong>
                                </td>
                                <td className="desc">
                                  {row?.TickerArabicName}
                                </td>
                                <td className="text-success">{`${row?.ChangePercent}%`}</td>
                                <td style={{ width: '50%' }}>
                                  <div className="progress p-0">
                                    <div
                                      className="progress-bar bg-success"
                                      style={{ width: `${percentageWidth}%` }}
                                    ></div>
                                  </div>
                                </td>
                              </tr>
                            </Link>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            ) : (
              <></>
            )}
          </div>
          <div className="col-md-6">
            <h3>الخاسرون</h3>
            {losers && losers?.length && losers?.length > 0 ? (
              <div className="table-responsive">
                <table className="table table-borderless">
                  <tbody>
                    {losers.map((loser: any, index: number) => {
                      const row = loser;
                      const percentageWidth =
                        index == 0
                          ? 100
                          : (row?.ChangePercent / losers[0]?.ChangePercent) *
                          100;
                          if (index >= 5) return null;
                      // console.log("1.",percentageWidth,"2.",row?.ChangePercent,"3.",losers[0]?.ChangePercent)
                      return (
                            <Link href={'/quotes/' + row?.TickerID} key={row?.TickerID}>
                              <tr className="marketMoversRow cursor-pointer" key={row?.TickerID}>
                                <td>
                                  <strong>{row?.TickerSymbol}</strong>
                                </td>
                                <td className="desc">
                                  {row?.TickerArabicName}
                                </td>
                                <td className="text-danger">
                                  {parseInt(row?.ChangePercent) > 0
                                    ? `${Math.abs(row?.ChangePercent)}%`
                                    : `${Math.abs(row?.ChangePercent)}%-`}
                                </td>
                                <td style={{ width: '50%' }}>
                                  <div className="progress p-0">
                                    <div
                                      className="progress-bar bg-danger"
                                      style={{
                                        width: `${Math.abs(percentageWidth)}%`,
                                      }}
                                    ></div>
                                  </div>
                                </td>
                              </tr>
                            </Link>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            ) : (
              <></>
            )}
          </div>
        </>
      )}
      {gainers?.length == 0 && losers?.length == 0 && (
        <div>هذا السوق مغلق حالياً, ستتوفر البيانات عند افتتاح السوق</div>
      )}
    </div>
  );
};

export default MarketMovers;
